"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    PluginTypes = _interopRequireWildcard(require("./PluginTypes")),
    Plugin = /*#__PURE__*/function () {
  function a() {
    var b = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "",
        c = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "";
    (0, _classCallCheck2["default"])(this, a), this.name = b, this.type = c;
  }

  return (0, _createClass2["default"])(a, [{
    key: "isSignatureProvider",
    value: function isSignatureProvider() {
      return this.type === PluginTypes.BLOCKCHAIN_SUPPORT;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return Object.keys(PluginTypes).map(function (a) {
        return PluginTypes[a];
      }).includes(this.type);
    }
  }], [{
    key: "placeholder",
    value: function placeholder() {
      return new a();
    }
  }, {
    key: "fromJson",
    value: function fromJson(b) {
      return Object.assign(a.placeholder(), b);
    }
  }]), a;
}();

exports["default"] = Plugin;